import React from 'react'

const Academic = ({studentData}) => {
    return (
        <div>
            <div className="p-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">Academic Information</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="bg-teal-50 rounded-xl p-6">
                        <h3 className="text-lg font-medium text-teal-800 mb-4">Student Details</h3>
                        <div className="space-y-4">
                            <div>
                                <p className="text-sm text-gray-500">Student ID</p>
                                <p className="font-medium">{studentData.studentId}</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Department</p>
                                <p className="font-medium">{studentData.department}</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Current Semester</p>
                                <p className="font-medium">Semester {studentData.semester}</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Enrollment Date</p>
                                <p className="font-medium">{new Date(studentData.enrollmentDate).toLocaleDateString()}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Academic;